import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Select from "react-dropdown-select";
import $ from "jquery";

import BuddibleSocket, { MsgIDList } from "../../../../lib/BuddibleSocket";
import CodeList from "../../../../lib/CodeList";
import Utilities from "../../../../lib/Utilities";

import CommonNav from "../../../CommonNav2";
import BannerMarketing from "../../BannerMarketing2";
import ScheduleAIRDirectTable from "./ScheduleAIRDirectTable";
// import ScheduleAIRPassThoughTable from "./ScheduleAIRPassThoughTable";
import ScheduleAirFreightCostModal from "./ScheduleAirFreightCostModal";
import Footer from "../../../Footer";

import LogoSvg from "../../../../assets/LogoSvg";
import CitySelect from "../../CitySelect";

window.jQuery = $;
window.$ = $;
global.jQuery = $;

const socket = new BuddibleSocket();
const util = new Utilities();
const codeList = new CodeList();

const _mClassName = "ScheduleAIR";
const shUUID = util.makeUUIDv4();

let loginInfo = null;

let isRequesting = false;
let rowsPerPage = 10;
let page = 0;
let pageSize = 0;
let totalCount = 0;
let totalPageCount = 0;
let filters = {
  sm_FCL_LCL: "AIR",
  sm_POL_CODE: "",
  sm_POD_CODE: "",
  sm_PROMO_YN: "",
  ORIGIN: "",
  DEST: "",
  SEARCH_DATE_START: "",
  SEARCH_DATE_END: "",
  sm_FWD_NO: "", //항공사
  sm_PROVIDER_CODE: "", //공급사
};

let modal_data = null; //{ mainData: {}, subData: {} };
let isSearch = false;
let isShareAccess = false;
let airline_list = [];
let supplier_list = [];
let isPromoState = null;

let schedule_air_list = [];
let today = new Date();
let currentMonth = today.getMonth() + 1;
if (currentMonth < 10) {
  currentMonth = `0${currentMonth}`;
}
currentMonth = currentMonth + "";

export default function ScheduleAIR(props) {
  const [isDirect, setIsDirect] = useState("Y");
  const [isCostModalOpen, setIsCostModalOpen] = useState(false);
  const [isScheduleLoad, setIsScheduleLoad] = useState(true);
  const [selectWeekDateList, setSelectWeekDateList] = useState({});
  const [searchHeight, setSearchHeight] = useState(540);
  const [isShowPOLSelect, setIsShowPOLSelect] = useState(false);
  const [isShowPODSelect, setIsShowPODSelect] = useState(false);

  const location = useLocation();
  const { t, i18n } = useTranslation();

  const $polRef = useRef();
  const $podRef = useRef();
  const $promo_check = useRef();

  function SELECT_AIRLINE_COMP_LIST() {
    const msgID = util.makeUUIDv4();
    const socketMsg = {
      file: "/airline/JS_airline_select.php",
      msgID: msgID,
      data: {},
      sm_FCL_LCL: "AIR",
    };

    socket.sendMessage(socketMsg, msgID, (beforeData, newData) => {
      if (newData) {
        if (newData["ret"]) {
          let dataList = newData["returnData"];
          let airline = [];
          let supplier = [];
          for (let i = 0; i < dataList.length; i++) {
            let data = dataList[i];
            if (data.AL_COMP_TYPE === "A") airline.push(data);
            if (data.AL_COMP_TYPE === "P") supplier.push(data);
          }
          airline_list = [...airline];
          supplier_list = [...supplier];
        }
      }
    });
  }

  (() => {
    SELECT_AIRLINE_COMP_LIST();
  })();

  useEffect(() => {
    if (location) {
      if (location.state && location.state.hasOwnProperty("type")) {
        if (location.state.type === "promo") {
          filters = {
            ...filters,
            sm_PROMO_YN: "Y",
          };
          isPromoState = { type: "promo" };
          $promo_check.current.checked = true;
        }
        if (location.state.hasOwnProperty("sm_POL_CODE")) {
          filters = {
            ...filters,
            sm_POL_CODE: location.state.sm_POL_CODE,
            sm_POD_CODE: location.state.sm_POD_CODE,
            ORIGIN: location.state.ORIGIN,
            DEST: location.state.DEST,
          };
          isSearch = true;
        }
      }
    }

    let userData = socket.getLocalDataSet(MsgIDList.EVENT_LOGIN_AUTO_SUCCESS);
    if (userData) {
      if (userData.ret) {
        loginInfo = userData["returnData"][0];
      }
    }

    socket.addLocalEventListener(
      MsgIDList.EVENT_LOGIN_AUTO_SUCCESS,
      _mClassName,
      (b, n) => {
        if (n) {
          if (n.ret) {
            loginInfo = n["returnData"][0];
          }
        }
      }
    );

    i18n.changeLanguage(i18n.language, (err) => {});
    makeWeekSelectOptions({ target: { value: currentMonth } });
    window.addEventListener("resize", resizeLayout);
    return () => {
      rowsPerPage = 10;
      page = 0;
      pageSize = 0;
      totalCount = 0;
      totalPageCount = 0;
      filters = {
        sm_FCL_LCL: "AIR",
        sm_POL_CODE: "",
        sm_POD_CODE: "",
        sm_PROMO_YN: "",
        ORIGIN: "",
        DEST: "",
        SEARCH_DATE_START: "",
        SEARCH_DATE_END: "",
        sm_FWD_NO: "", //항공사
        sm_PROVIDER_CODE: "", //공급사
      };

      modal_data = null;
      isSearch = false;
      isShareAccess = false;
      isPromoState = null;
      schedule_air_list = [];
      window.removeEventListener("resize", resizeLayout);
      socket.removeLocalEventListener(
        MsgIDList.EVENT_LOGIN_AUTO_SUCCESS,
        _mClassName
      );
      socket.removeLocalEventListener(
        MsgIDList.EVENT_INIT_CODE_COUNTRY_FULL_NAME,
        _mClassName
      );
    };
  }, []);

  function resizeLayout() {
    if (window.innerWidth < 992) {
      setSearchHeight(800);
    } else {
      setSearchHeight(540);
    }
  }

  // 항공 스케쥴 데이터 select
  function SELECT_AIR_SCHEDULE_LIST() {
    setIsScheduleLoad(true);
    const msgID = util.makeUUIDv4();
    const socketMsg = {
      file: "/schedule_air/JS_schedule_air_select.php",
      msgID: msgID,
      data: {},
      take: rowsPerPage,
      skip: page * rowsPerPage,
      page: page + 1,
      pageSize: 5,
      sort: [
        {
          field: "sm_DEPARTURE_DATE",
          dir: "asc",
        },
      ],
      sp_DISPLAY: 0,
      ...filters,
    };

    socket.sendMessage(socketMsg, msgID, (beforeData, newData) => {
      if (newData) {
        if (newData["ret"]) {
          schedule_air_list =
            newData["returnData"].length > 0
              ? [...schedule_air_list, ...newData["returnData"]]
              : [];

          pageSize = newData.pageSize;
          totalCount = parseInt(newData.pageSize, 10);
          totalPageCount =
            schedule_air_list.length > 0
              ? parseInt(
                  parseInt(newData.pageSize, rowsPerPage) / rowsPerPage,
                  rowsPerPage
                ) +
                (parseInt(newData.pageSize, rowsPerPage) % rowsPerPage > 0
                  ? 1
                  : 0)
              : 0;
          setIsScheduleLoad(false);
        }
      }
    });
  }

  function changedFilters(data) {
    filters = {
      ...filters,
      ...data,
    };
    if (data.hasOwnProperty("sm_PROMO_YN")) {
      page = 0;
      isSearch = true;
      schedule_air_list = [];
      setIsScheduleLoad(true);
      SELECT_AIR_SCHEDULE_LIST();
    }
  }

  //스케줄 검색
  function clickSearch() {
    page = 0;
    isSearch = true;
    schedule_air_list = [];
    SELECT_AIR_SCHEDULE_LIST();
  }

  //검색필터 초기화
  function handleResetFilters() {
    $polRef.current.value = "";
    $podRef.current.value = "";
    $promo_check.current.checked = false;
    page = 0;
    filters = {
      sm_FCL_LCL: "AIR",
      sm_DOC_CLOSE: util.todayDate("YYYY-MM-DD"),
      sm_POL_CODE: "",
      sm_POD_CODE: "",
      sm_PROMO_YN: "",
      ORIGIN: "",
      DEST: "",
      SEARCH_DATE_START: "",
      SEARCH_DATE_END: "",
      sm_FWD_NO: "", //항공사
      sm_PROVIDER_CODE: "", //공급사
    };
    isSearch = false;
    isPromoState = false;
    schedule_air_list = [];
    SELECT_AIR_SCHEDULE_LIST();
  }

  function handleCostModalOpen(mainData, subData) {
    if (!loginInfo) {
      codeList.Modal.current.alert(t("schedule.msg.requiresLogin"));
      return false;
    }

    if (!util.checkCompGB(loginInfo)) {
      codeList.Modal.current.alert(t("schedule.msg.onlyForwarder"));
      return;
    }

    if (mainData && subData) {
      modal_data = { mainData, subData };
      setIsCostModalOpen(true);
      return;
    }
    modal_data = null;
    setIsCostModalOpen(false);
  }

  // 사용자 이용로그
  function handleUseHistoryData(data) {
    let log_data = {
      shUUID: shUUID,
      shIDX: "", //스케줄 No
      shDate: filters.sm_DOC_CLOSE, // 검색일자(출발일)
      shType: filters.sm_FCL_LCL, // FCL,LCL,항공
      shORIGIN: filters.sm_POL_CODE, //출발지 POL
      shDEST: filters.sm_POD_CODE, //도착지 POD
      shClick: 0, //클릭여부
      shClickFor: "", //클릭 분류
      shMethod: window.location.href, //발생 URL
      ...data,
    };
    if (loginInfo && loginInfo.hasOwnProperty("user_id")) {
      log_data["shCOMPCD"] = loginInfo.comp_cd;
      log_data["shUSERID"] = loginInfo.user_id;
    }

    INSERT_SCHEDULE_USE_HISTORY(log_data);
  }

  //사용자 접근 경로 데이터
  function INSERT_SCHEDULE_USE_HISTORY(data) {
    const msgID = util.makeUUIDv4();
    const socketMsg = {
      file: "/schedule/JS_schedule_select_log_insert.php",
      msgID: msgID,
      data: {},
      ...data,
    };
    socket.sendMessage(socketMsg, msgID, () => {});
  }

  //페이지 이동
  function handleChangePage(val) {
    if (schedule_air_list.length === Number(pageSize) || isRequesting) return;
    isRequesting = true;
    page = val;
    const currentScrollTop = document.documentElement.scrollTop;
    window.scrollTo(0, currentScrollTop);
    SELECT_AIR_SCHEDULE_LIST();
  }

  // 주단위 선택 핸들러
  function handleSearchDate(value) {
    let splitValue = value.split(" : ")[1].split("|");
    let startDate = new Date(splitValue[0]);
    let endDate = new Date(splitValue[1]);

    let sYear = startDate.getFullYear();
    let sMonth = startDate.getMonth() + 1;
    let sDate = startDate.getDate();

    let sLastDate = new Date(sYear, sMonth, 0);

    let eMonth = endDate.getMonth() + 1;

    let days = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
    let dateList = {};
    let cnt = 0;
    for (let i = 0; i < 7; i++) {
      let dateTxt = "";

      let month = 0;
      let date = 0;
      if (sDate + i > sLastDate.getDate()) {
        ++cnt;
        month = eMonth;
        date = cnt;
      } else {
        month = sMonth;
        date = sDate + i;
      }

      month = month < 10 ? "0" + month : month;
      date = date < 10 ? "0" + date : date;
      const realDate = new Date(new Date().getFullYear(), month - 1, date);

      dateTxt = `[${month}/${date}]`;
      dateList[days[i]] = { dateTxt: dateTxt, realDate: realDate };
      //dateList[days[i]] = dateTxt;
    }
    filters = {
      ...filters,
      SEARCH_DATE_START: splitValue[0],
      SEARCH_DATE_END: splitValue[1],
    };
    setSelectWeekDateList(dateList);
    SELECT_AIR_SCHEDULE_LIST();
  }

  function makeWeekSelectOptions(e) {
    let year = today.getFullYear();
    let month = e.target.value;

    let sDate = new Date(year, month - 1, 1);
    let lastDay = new Date(
      sDate.getFullYear(),
      sDate.getMonth() + 1,
      0
    ).getDate();
    let endDate = new Date(sDate.getFullYear(), sDate.getMonth(), lastDay);

    let week = sDate.getDay();
    sDate.setDate(sDate.getDate() - week);
    let eDate = new Date(
      sDate.getFullYear(),
      sDate.getMonth(),
      sDate.getDate()
    );

    let obj = document.getElementById("sh_week");
    obj.options.length = 0;
    let seled = "";
    let weekCount = 1;

    while (endDate.getTime() >= eDate.getTime()) {
      let sYear = sDate.getFullYear();
      let sMonth = sDate.getMonth() + 1;
      let sDay = sDate.getDate();

      sMonth = sMonth < 10 ? "0" + sMonth : sMonth;
      sDay = sDay < 10 ? "0" + sDay : sDay;

      let stxt =
        t("schedule.air.weekRangeEN") +
        " " +
        weekCount +
        t("schedule.air.weekRange") +
        " : " +
        sYear +
        "-" +
        sMonth +
        "-" +
        sDay;

      eDate.setDate(sDate.getDate() + 6);

      let eYear = eDate.getFullYear();
      let eMonth = eDate.getMonth() + 1;
      let eDay = eDate.getDate();

      eMonth = eMonth < 10 ? "0" + eMonth : eMonth;
      eDay = eDay < 10 ? "0" + eDay : eDay;

      let etxt = eYear + "-" + eMonth + "-" + eDay;

      if (
        today.getTime() > sDate.getTime() &&
        today.getTime() < eDate.getTime()
      ) {
        seled = stxt + "|" + etxt;
      }

      obj.options[obj.options.length] = new Option(
        stxt + "~" + etxt,
        stxt + "|" + etxt
      );
      obj.options[obj.options.length - 1].setAttribute("class", "text-dark");

      sDate = new Date(
        eDate.getFullYear(),
        eDate.getMonth(),
        eDate.getDate() + 1
      );
      eDate = new Date(sDate.getFullYear(), sDate.getMonth(), sDate.getDate());
      weekCount += 1;
    }

    if (seled) {
      obj.value = seled;
      handleSearchDate(seled);
    }
  }

  return (
    <>
      <CommonNav />
      {modal_data && isCostModalOpen && (
        <ScheduleAirFreightCostModal
          loginInfo={loginInfo}
          modal_data={modal_data}
          handleCostModalOpen={handleCostModalOpen}
        />
      )}
      <main className="mh-90vh bg-schedule">
        <div className="position-relative" style={{ height: searchHeight }}>
          <img
            src={
              "https://gbts-invoice.s3.ap-northeast-2.amazonaws.com/talk/chatRoom/Z0001/amber.jung@buddible.com/20250807102920_gbts_carousel.3.jpg"
            }
            alt="bg"
            className="w-100 position-absolute"
            style={{ top: 0, left: 0, height: searchHeight }}
          />
          <div
            className="w-100 h-100 position-absolute d-flex flex-column justify-content-center align-items-center"
            style={{
              background:
                "linear-gradient(to bottom, rgba(255,255,255,0.2), rgba(19, 22, 56,0.4))",
            }}
          />

          <div
            className="position-absolute w-100 h-100  d-flex flex-column justify-content-center align-items-center"
            style={{ zIndex: 2 }}
          >
            <div className="container mb-3 ">
              <div className="px-3">
                <p className="h4 font-weight-bold d-flex flex-row align-items-end flex-wrap position-relative">
                  <LogoSvg width="200px" color="#fff" point="#0097b7" />
                </p>
                <p className="h4 text-white font-weight-bold">
                  {t("schedule.title")}
                </p>
                <p className="h5 text-white mb-0">
                  {t("schedule.description")}
                </p>
              </div>
            </div>
            <div className="container">
              <div
                id="search-air"
                className="rounded shadow"
                style={{
                  background: "rgba(255,255,255,0.3)",
                  backdropFilter: "blur(10px)",
                  WebkitBackdropFilter: "blur(10px)",
                  border: "1px solid rgba(255, 255, 255, 0.1)",
                  color: "#fff",
                }}
              >
                <div
                  className="row m-0 p-0 text-center text-white"
                  style={{ borderBottom: "1px solid rgba(255, 255, 255, 0.3)" }}
                >
                  <Link
                    to={"/ScheduleLCL"}
                    className="col-4 m-0 p-0 py-2 text-white text-decoration-none rounded-top-right"
                    state={isPromoState}
                    style={{
                      borderRight: "1px solid rgba(255, 255, 255, 0.3)",
                    }}
                  >
                    {t("schedule.lcl.title")}
                  </Link>
                  <Link
                    to={"/ScheduleFCL"}
                    className="col-4 m-0 p-0 py-2 text-white text-decoration-none"
                    state={isPromoState}
                    style={{
                      borderRight: "1px solid rgba(255, 255, 255, 0.3)",
                    }}
                  >
                    {t("schedule.fcl.title")}
                  </Link>
                  <Link
                    to={"/ScheduleAIR"}
                    className="col-4 m-0 p-0 py-2 bg-freiscop text-white text-decoration-none rounded-top-right font-weight-bold"
                    state={isPromoState}
                  >
                    <span className="font-size-09">
                      <i className="fa-solid fa-cart-flatbed" />
                    </span>{" "}
                    {t("schedule.air.title")}
                  </Link>
                </div>
                <div className="row m-0 p-0 rounded-bottom-left rounded-bottom-right">
                  <div className="col-12 col-lg-4 m-0 p-2 px-lg-3">
                    <p className="font-size-09 font-weight-bold">
                      {t("schedule.air.weekRange")}
                      {t("schedule.air.weekRangeEN")}
                    </p>
                    <div className="d-flex flex-row border-bottom">
                      <select
                        className="border-0 py-2 bg-transparent text-white"
                        defaultValue={currentMonth}
                        onChange={(e) => makeWeekSelectOptions(e)}
                      >
                        <option className="text-dark" value="">
                          -{t("commonDate.month.month")}-
                        </option>
                        <option className="text-dark" value="01">
                          {t("commonDate.month.january")}
                        </option>
                        <option className="text-dark" value="02">
                          {t("commonDate.month.february")}
                        </option>
                        <option className="text-dark" value="03">
                          {t("commonDate.month.march")}
                        </option>
                        <option className="text-dark" value="04">
                          {t("commonDate.month.april")}
                        </option>
                        <option className="text-dark" value="05">
                          {t("commonDate.month.may")}
                        </option>
                        <option className="text-dark" value="06">
                          {t("commonDate.month.june")}
                        </option>
                        <option className="text-dark" value="07">
                          {t("commonDate.month.july")}
                        </option>
                        <option className="text-dark" value="08">
                          {t("commonDate.month.august")}
                        </option>
                        <option className="text-dark" value="09">
                          {t("commonDate.month.september")}
                        </option>
                        <option className="text-dark" value="10">
                          {t("commonDate.month.october")}
                        </option>
                        <option className="text-dark" value="11">
                          {t("commonDate.month.november")}
                        </option>
                        <option className="text-dark" value="12">
                          {t("commonDate.month.december")}
                        </option>
                      </select>
                      <select
                        id="sh_week"
                        className="border-0 flex-fill py-2 bg-transparent text-white"
                        style={{ minWidth: 225 }}
                        onChange={(e) => {
                          handleSearchDate(e.target.value);
                        }}
                      >
                        <option className="text-dark" value="">
                          -월을 선택해주세요-
                        </option>
                      </select>
                    </div>
                  </div>
                  <div className="col-12 col-lg-4 m-0 p-2 px-lg-3">
                    <p className="font-size-09 font-weight-bold">
                      {t("schedule.departure")}
                    </p>
                    <div
                      className="position-relative"
                      style={{ paddingTop: 2 }}
                    >
                      <input
                        type="text"
                        className="w-100 border-top-0 border-left-0 border-right-0 border-bottom py-1 bg-transparent text-white"
                        ref={$polRef}
                        readOnly={true}
                        onClick={() => setIsShowPOLSelect(true)}
                      />
                      <span
                        className="position-absolute cursor_pointer text-danger h6 mb-0"
                        style={{ right: 6 }}
                        onClick={() => {
                          const data = {
                            ORIGIN: "",
                            sm_POL_CODE: "",
                          };
                          $polRef.current.value = "";
                          changedFilters(data);
                          setIsShowPOLSelect(false);
                        }}
                      >
                        &times;
                      </span>
                    </div>

                    <div className={isShowPOLSelect ? "" : "d-none"}>
                      <CitySelect
                        isAir={true}
                        isShow={isShowPOLSelect}
                        setIsShow={setIsShowPOLSelect}
                        callback={(res) => {
                          const data = {
                            ORIGIN: res["CityName"],
                            sm_POL_CODE: res["CustomCode"],
                          };
                          $polRef.current.value = `${res["CityName"]}(${res[
                            "CityName_EN"
                          ].trim()})`;
                          changedFilters(data);
                          setIsShowPOLSelect(false);
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-lg-4 m-0 p-2 px-lg-3">
                    <p className="font-size-09 font-weight-bold">
                      {t("schedule.arrival")}
                    </p>

                    <div
                      className="position-relative"
                      style={{ paddingTop: 2 }}
                    >
                      <input
                        type="text"
                        className="w-100 border-top-0 border-left-0 border-right-0 border-bottom py-1 bg-transparent text-white"
                        ref={$podRef}
                        readOnly={true}
                        onClick={() => setIsShowPODSelect(true)}
                      />
                      <span
                        className="position-absolute cursor_pointer text-danger h6 mb-0"
                        style={{ right: 6 }}
                        onClick={() => {
                          const data = {
                            DEST: "",
                            sm_POD_CODE: "",
                          };
                          $podRef.current.value = "";
                          changedFilters(data);
                          setIsShowPODSelect(false);
                        }}
                      >
                        &times;
                      </span>
                    </div>

                    <div className={isShowPODSelect ? "" : "d-none"}>
                      <CitySelect
                        isAir={true}
                        isShow={isShowPODSelect}
                        setIsShow={setIsShowPODSelect}
                        callback={(res) => {
                          const data = {
                            DEST: res["CityName"],
                            sm_POD_CODE: res["CustomCode"],
                          };
                          $podRef.current.value = `${res["CityName"]}(${res[
                            "CityName_EN"
                          ].trim()})`;
                          changedFilters(data);
                          setIsShowPODSelect(false);
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-lg-4 m-0 p-2 px-lg-3">
                    <p className="font-size-09 font-weight-bold">
                      {t("schedule.air.airline")}
                    </p>
                    <Select
                      placeholder={t("schedule.air.msg.selectCompany")}
                      className="w-100 p-0 m-0 border-top-0 border-left-0 border-right-0 border-bottom"
                      multi
                      clearable
                      values={[]}
                      options={airline_list}
                      name={"AL_COMP_NM"}
                      sortBy={"AL_COMP_NM"}
                      searchBy={"AL_COMP_NM"}
                      valueField={"AL_COMP_CD"}
                      labelField={"AL_COMP_NM"}
                      autoFocus={false}
                      onChange={(value) => {
                        if (value.length < 1) {
                          changedFilters({ sm_FWD_NO: "" });
                          return;
                        }

                        let airlineKeys = [];
                        for (let i = 0; i < value.length; i++) {
                          let comp = value[i];
                          airlineKeys.push(comp.AL_COMP_CD);
                        }

                        airlineKeys = airlineKeys.join("|");
                        changedFilters({ sm_FWD_NO: airlineKeys });
                      }}
                      noDataRenderer={() => {
                        return (
                          <div className="px-2 py-1 font-weight-bold text-dark">
                            - {t("schedule.air.msg.noData")} -
                          </div>
                        );
                      }}
                      itemRenderer={({ item, itemIndex, methods }) => {
                        return (
                          <div key={itemIndex}>
                            <div
                              role="option"
                              aria-selected="false"
                              tabIndex="-1"
                              className="react-dropdown-select-item css-148o527-ItemComponent evc32pp0 cursor_pointer_bg_light px-2 py-1 d-flex flex-row align-items-center text-dark"
                              onClick={() => {
                                methods.addItem(item);
                              }}
                            >
                              {item.AL_COMP_LOGO && (
                                <div
                                  className="d-inline-block mr-2"
                                  style={{
                                    width: "1rem",
                                    height: "1rem",
                                    background: `url(${item.AL_COMP_LOGO}) 50% 50% / contain no-repeat`,
                                  }}
                                />
                              )}
                              <p className="d-inline-block">
                                <b>{item.AL_COMP_NM}</b>{" "}
                                <span className="font-size-08">
                                  [{item.AL_COMP_NM_EN}]
                                </span>
                              </p>
                            </div>
                          </div>
                        );
                      }}
                    />
                  </div>
                  <div className="col-12 col-lg-4 m-0 p-2 px-lg-3">
                    <p className="font-size-09 font-weight-bold">
                      {t("schedule.air.supplier")}
                    </p>
                    <Select
                      placeholder={t("schedule.air.msg.selectCompany")}
                      className="w-100 p-0 m-0 border-top-0 border-left-0 border-right-0 border-bottom"
                      multi
                      clearable
                      values={[]}
                      options={supplier_list}
                      name={"AL_COMP_NM"}
                      sortBy={"AL_COMP_NM"}
                      searchBy={"AL_COMP_NM"}
                      valueField={"AL_COMP_CD"}
                      labelField={"AL_COMP_NM"}
                      autoFocus={false}
                      onChange={(value) => {
                        if (value.length < 1) {
                          changedFilters({ sm_PROVIDER_CODE: "" });
                          return;
                        }

                        let airlineKeys = [];
                        for (let i = 0; i < value.length; i++) {
                          let comp = value[i];
                          airlineKeys.push(comp.AL_COMP_CD);
                        }

                        airlineKeys = airlineKeys.join("|");
                        changedFilters({ sm_PROVIDER_CODE: airlineKeys });
                      }}
                      noDataRenderer={() => {
                        return (
                          <div className="px-2 py-1 font-weight-bold text-dark">
                            - {t("schedule.air.msg.noData")} -
                          </div>
                        );
                      }}
                      itemRenderer={({ item, itemIndex, methods }) => {
                        return (
                          <div key={itemIndex}>
                            <div
                              role="option"
                              aria-selected="false"
                              tabIndex="-1"
                              className="react-dropdown-select-item css-148o527-ItemComponent evc32pp0 cursor_pointer_bg_light px-2 py-1 d-flex flex-row align-items-center text-dark"
                              onClick={() => {
                                methods.addItem(item);
                              }}
                            >
                              {item.AL_COMP_LOGO && (
                                <div
                                  className="d-inline-block mr-2"
                                  style={{
                                    width: "1rem",
                                    height: "1rem",
                                    background: `url(${item.AL_COMP_LOGO}) 50% 50% / contain no-repeat`,
                                  }}
                                />
                              )}
                              <p className="d-inline-block">
                                <b>{item.AL_COMP_NM}</b>{" "}
                                <span className="font-size-08">
                                  [{item.AL_COMP_NM_EN}]
                                </span>
                              </p>
                            </div>
                          </div>
                        );
                      }}
                    />
                  </div>
                  <div className="col-12 col-lg-4 m-0 p-2 px-lg-3">
                    <p></p>
                    <div className="d-flex flex-row">
                      <select
                        className="d-inline-block border-top-0 border-left-0 border-right-0 border-bottom bg-transparent py-1 mr-3 text-white"
                        onChange={(e) => {
                          setIsDirect(e.target.value);
                        }}
                      >
                        <option className="text-dark" value="Y">
                          {t("schedule.air.direct")}
                        </option>
                        <option className="text-dark" value="N">
                          {t("schedule.air.transit")}
                        </option>
                      </select>
                      <label className="container_check m-0 mb-2 mb-lg-0 mr-lg-3 p-0">
                        <input
                          type="checkbox"
                          className="position-static"
                          defaultChecked={filters.sm_PROMO_YN === "Y"}
                          ref={$promo_check}
                          onChange={(e) => {
                            isPromoState = e.target.checked
                              ? { type: "promo" }
                              : null;
                            changedFilters({
                              sm_PROMO_YN: e.target.checked ? "Y" : "",
                            });
                          }}
                        />
                        <span className="checkmark" />
                        <span className="ml-3">
                          {t("schedule.air.promotion")}
                        </span>
                      </label>
                    </div>
                  </div>
                  <div className="col-12 m-0 p-2 px-lg-3 d-flex flex-row justify-content-end">
                    <button
                      className="btn_1 px-4 mr-2 rounded-sm"
                      onClick={clickSearch}
                    >
                      {t("schedule.search")}
                    </button>
                    <button
                      className="btn_1 bg-secondary border-secondary rounded-sm"
                      onClick={handleResetFilters}
                    >
                      {t("schedule.reset")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container margin_30 mt-0">
          <div className="row">
            <div className="col-12 my-2">
              <p className="h6 font-weight-bold mb-0 mt-1 px-2">
                {t("schedule.total")}{" "}
                <span className="text-info font-weight-bold">
                  {util.addCommas(pageSize)}
                  {t("schedule.items")}
                </span>
                {t("schedule.searched")}
              </p>
            </div>
            <div className="col-12 m-0 mb-2 p-0">
              <BannerMarketing />
            </div>
            <div className="col-12">
              {schedule_air_list.length > 0 && isDirect === "Y" && (
                <ScheduleAIRDirectTable
                  loginInfo={loginInfo}
                  page={page}
                  totalPageCount={totalPageCount}
                  schedule_air_list={schedule_air_list}
                  filters={filters}
                  selectWeekDateList={selectWeekDateList}
                  airline_list={airline_list}
                  supplier_list={supplier_list}
                  handleCostModalOpen={handleCostModalOpen}
                  handleChangePage={handleChangePage}
                  handleUseHistoryData={handleUseHistoryData}
                />
              )}
              {schedule_air_list.length === 0 && !isScheduleLoad && (
                <div className="bg-white rounded p-5 h6 text-center">
                  {t("schedule.msg.noSchedule")}
                </div>
              )}
              {isScheduleLoad && (
                <div className="rounded p-5 h6 text-center">
                  <div className="d-flex justify-content-center">
                    <div
                      className="spinner-grow text-secondary"
                      role="status"
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
